<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/vJoLRF/tc-custom/cover.jpg?1685327667880?1688968472400" alt="This image is the cover for the book Loss of Heart"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Loss of Heart
      </h1>
      <p class="bookDescription body article font2">
        <p>Daryl Maven and Adam Rossi are comfortable in their relationship, but they can’t agree on whether to marry. Daryl, a law student who teaches college English part-time, wants to wait until gay marriage is recognized in their home state. Adam, also a student, doesn’t want to wait for any reason before making that ultimate commitment.</p> <p>Everything changes when Daryl is brutally assaulted. Withdrawn and paranoid, he becomes so fixated on finding his attacker that his obsession threatens his bond with Adam. Adam’s commitment will truly be tested as he endeavors to support Daryl, but unless Daryl heals his emotional wounds, their relationship—marriage or not—can’t survive.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Evan Gilbert
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2660020e